module.exports = __webpack_public_path__ + "static/media/WU_DeleteCard.5ed9d299.svg";